const rTicker = document.querySelector(".r-ticker_track")

if (rTicker) {

  gsap.to(".r-ticker_track", {
    x: "-100%",
    duration: 32,
    ease: "none",
    repeat: -1, // This makes the animation loop indefinitely
    repeatDelay: 0, // Ensures no delay between loops
  });

}
